'use client';

import { c as _c } from "react/compiler-runtime";
import { TransitionStartFunction, useEffect, useState } from 'react';
import { Alert, BodyShort, CopyButton, HStack, InlineMessage, Link, ReadMore, Search, Tag, VStack } from '@navikt/ds-react';
import { setBreadcrumbs } from '@navikt/nav-dekoratoren-moduler';
import { hentArbeidssted } from '../_actions/hentArbeidssted';
import styles from './HovedEnhet.module.css';
import UnderenhetKortliste from './UnderenhetKortliste';
import { store } from '@/app/_components/store/store';
import SortedTable from '@/components/sorted-table';
import Spinner from '@/components/spinner/Spinner';
import { areaPath } from '@/urls';
import { formatOrgnr } from '@/utils/formatting/tall';
import { useErKortliste } from '@/utils/mediaQueries';
import NavnIdentHeader from 'components/navn-ident-header/NavnIdentHeader';
export const Hovedenhet = t0 => {
  const $ = _c(26);
  const {
    loading: t1,
    startTransition
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const {
    tekst
  } = store.useReducerState();
  const erKortliste = useErKortliste();
  const {
    SET_ARBEIDSGIVER_VIEW,
    REQUEST_ARBEIDSGIVER_ARBEIDSSTED,
    SET_ARBEIDSGIVER_ARBEIDSSTED
  } = store.useActions();
  const valgtOrg = store.useReducerState().bruker.valgtOrg;
  const [soketekst, setSoketekst] = useState(undefined);
  let t2;
  if ($[0] !== tekst._prefix || $[1] !== tekst.landing.arbeidsgiver.heading) {
    t2 = () => {
      setBreadcrumbs([{
        title: tekst.landing.arbeidsgiver.heading,
        url: areaPath("arbeidsgiver", tekst._prefix),
        handleInApp: true
      }]);
    };
    $[0] = tekst._prefix;
    $[1] = tekst.landing.arbeidsgiver.heading;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== tekst) {
    t3 = [tekst];
    $[3] = tekst;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== REQUEST_ARBEIDSGIVER_ARBEIDSSTED || $[6] !== SET_ARBEIDSGIVER_ARBEIDSSTED || $[7] !== SET_ARBEIDSGIVER_VIEW || $[8] !== startTransition) {
    t4 = orgnr => {
      SET_ARBEIDSGIVER_VIEW("arbeidssted");
      REQUEST_ARBEIDSGIVER_ARBEIDSSTED();
      startTransition(async () => {
        SET_ARBEIDSGIVER_ARBEIDSSTED(await hentArbeidssted(orgnr));
      });
    };
    $[5] = REQUEST_ARBEIDSGIVER_ARBEIDSSTED;
    $[6] = SET_ARBEIDSGIVER_ARBEIDSSTED;
    $[7] = SET_ARBEIDSGIVER_VIEW;
    $[8] = startTransition;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const onSelectArbeidssted = t4;
  let t5;
  let underenheter;
  if ($[10] !== soketekst || $[11] !== valgtOrg?.underenheter) {
    underenheter = valgtOrg?.underenheter.filter(_temp) ?? [];
    t5 = soketekst ? underenheter?.filter(underenhet => underenhet.navn.toLowerCase().includes(soketekst.toLowerCase()) || underenhet.orgnr.includes(soketekst)) : underenheter;
    $[10] = soketekst;
    $[11] = valgtOrg?.underenheter;
    $[12] = t5;
    $[13] = underenheter;
  } else {
    t5 = $[12];
    underenheter = $[13];
  }
  const filteredUnderenheter = t5;
  const hasUnderenheter = underenheter && underenheter.length > 0;
  let t6;
  if ($[14] !== erKortliste || $[15] !== filteredUnderenheter || $[16] !== hasUnderenheter || $[17] !== loading || $[18] !== onSelectArbeidssted || $[19] !== soketekst || $[20] !== tekst.arbeidsgiverHovedenhet || $[21] !== tekst.term || $[22] !== tekst.underenhetTableRow || $[23] !== underenheter || $[24] !== valgtOrg) {
    t6 = loading ? <Spinner tekst="Laster underenheter..." /> : <VStack gap="space-24"><NavnIdentHeader navn={valgtOrg?.navn} ident={valgtOrg.orgnr} kopiAriaLabel={`${tekst.underenhetTableRow.copyIdent}${valgtOrg?.navn}`} merkelapp={<Tag size="xsmall" variant="outline">{tekst.arbeidsgiverHovedenhet.merkelapp}</Tag>} />{hasUnderenheter ? <><InlineMessage status="info">{tekst.arbeidsgiverHovedenhet.underenheterInfo}<span className={styles.utfyllendeInfo}>{tekst.arbeidsgiverHovedenhet.undetenheterInfo2}</span><ReadMore className={styles.utfyllendeInfoKompakt} size="small" header={tekst.arbeidsgiverHovedenhet.lesMer}>{tekst.arbeidsgiverHovedenhet.undetenheterInfo2}</ReadMore></InlineMessage><div className={styles.searchContainer}><Search variant="secondary" value={soketekst} onChange={setSoketekst} placeholder={tekst.arbeidsgiverHovedenhet.sokPlaceholder} label={tekst.arbeidsgiverHovedenhet.sokLabel} clearButtonLabel={tekst.arbeidsgiverHovedenhet.clearUnderenhetButtonLabel} /></div>{filteredUnderenheter.length > 0 ? <div><BodyShort size="small" className={styles.antall} aria-live="polite">{tekst.arbeidsgiverHovedenhet.viserAntall.replace("%s", String(filteredUnderenheter.length)).replace("%s", String(underenheter.length))}</BodyShort>{erKortliste ? <UnderenhetKortliste underenheter={filteredUnderenheter} onVelgUnderenhet={onSelectArbeidssted} /> : <SortedTable simple={true} fields={[{
            label: tekst.term.navn,
            sortValue: _temp2,
            getValue: value_0 => <Link as="button" type="button" className={styles.underenhetLenke} onClick={() => onSelectArbeidssted(value_0.orgnr)}>{value_0.navn}</Link>
          }, {
            label: tekst.term.organisasjonsnummer,
            getValue: value_1 => <HStack align="center" gap="space-4"><BodyShort>{formatOrgnr(value_1.orgnr)}</BodyShort><CopyButton size="xsmall" copyText={value_1.orgnr} aria-label={`${tekst.underenhetTableRow.copyIdent}${value_1.navn}`} /></HStack>,
            sortable: false
          }, {
            label: tekst.term.arbeidsforhold,
            sortValue: _temp3,
            getValue: value_3 => <HStack gap="space-12">{value_3.antallAktiveArbeidsforhold ? <Tag size="small" data-color="success">{`${value_3.antallAktiveArbeidsforhold} ${tekst.underenhetTableRow.aktiveArbForhold}`}</Tag> : value_3.antallInaktiveArbeidsforhold ? <Tag size="small">{`${value_3.antallInaktiveArbeidsforhold} ${tekst.underenhetTableRow.inaktiveArbForhold}`}</Tag> : null}</HStack>
          }]} initialData={filteredUnderenheter || []} />}</div> : <Alert style={{
          marginTop: "1rem"
        }} variant="info">{tekst.arbeidsgiverHovedenhet.fantIkkeUnderenhet}</Alert>}</> : <Alert style={{
        marginTop: "1rem"
      }} variant="info">{tekst.arbeidsgiverHovedenhet.ingenUnderenheter}</Alert>}</VStack>;
    $[14] = erKortliste;
    $[15] = filteredUnderenheter;
    $[16] = hasUnderenheter;
    $[17] = loading;
    $[18] = onSelectArbeidssted;
    $[19] = soketekst;
    $[20] = tekst.arbeidsgiverHovedenhet;
    $[21] = tekst.term;
    $[22] = tekst.underenhetTableRow;
    $[23] = underenheter;
    $[24] = valgtOrg;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
};
function _temp(org) {
  return org.harAnsatte;
}
function _temp2(value) {
  return value.navn;
}
function _temp3(value_2) {
  return value_2.antallAktiveArbeidsforhold;
}